import React, { useState } from "react";
import "./gratitude-card.scss";
import { TbDots } from "react-icons/tb";
import {
  DeleteIcon,
  EditIcon,
} from "../../../../../assets/icons/dropdownIcons";
import { Dropdown, notification } from "antd";
import { GratitudeService } from "../../../../services/gratitude-api.service";
import { RoundedCheck } from "../../../../../assets/icons/defaultIcons";
import ThemeModals from "../../../common/modals/theme-modals/ThemeModals";
import EditGratitude from "../../../../views/dashboard/home/gratitude/EditGratitude";
import ActionModal from "../../../common/modals/action-modal/ActionModal";

const DespFunc = ({ des }) => {
  const paragraphs = des?.split(/\n{2,}/)?.map((para, paraIndex) => {
    const lines = para?.split("\n")?.map((line, lineIndex) => (
      <React.Fragment key={`${paraIndex}-${lineIndex}`}>
        {line}
        <br />
      </React.Fragment>
    ));

    return (
      <div key={paraIndex} style={{ marginBottom: "16px" }}>
        {lines}
      </div>
    );
  });

  return <p>{paragraphs}</p>;
};

export default function ({
  heading,
  des,
  date,
  id,
  getListing,
  setGetListing,
}) {
  const [editGratitude, setEditGratitude] = useState(false);
  const [deleteGratitude, setDeleteGratitude] = useState(false);
  const [loader, setLoader] = useState(false);
  async function DeleteGratitude(id) {
    setLoader(true);
    const response = await GratitudeService.deleteGratitude(id);
    if (response?.data?.data?.status) {
      setGetListing(!getListing);
      notification.success({
        message: "Success",
        description: response?.data?.message,
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setLoader(false);
    } else {
      notification.success({
        message: "Success",
        description: response?.data?.message,
        placement: "topRight",
        icon: <RoundedCheck />,
        duration: 2,
      });
      setLoader(false);
    }
  }

  const items = [
    {
      key: "1",
      label: (
        <span
          onClick={() => {
            setEditGratitude(true);
          }}
        >
          <EditIcon /> Edit{" "}
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <span
          onClick={() => {
            setDeleteGratitude(true);
          }}
        >
          <DeleteIcon /> Delete
        </span>
      ),
    },
  ];
  return (
    <div className={"gratitude-card"}>
      <div>
        <h3>{heading}</h3>
        <DespFunc des={des} />
      </div>

      <div className={"options"}>
        <div className={"date"}>
          <span>{date}</span>
        </div>
        <div className={"dots cp"}>
          <span>
            <Dropdown
              menu={{ items }}
              overlayClassName={"drop-2"}
              placement="bottomLeft"
              trigger={"click"}
            >
              <TbDots />
            </Dropdown>
          </span>
        </div>
      </div>

      <ThemeModals
        open={editGratitude}
        close={setEditGratitude}
        title={heading}
        content={
          <EditGratitude
            close={setEditGratitude}
            getListing={getListing}
            setGetListing={setGetListing}
            id={id}
          />
        }
      />
      <ActionModal
        show={deleteGratitude}
        close={setDeleteGratitude}
        modalHeading={"Delete Journal"}
        modalText={"Are you sure you want to delete?"}
        cancelBTnText={"Cancel"}
        actionBTnText={"Delete"}
        // loader={loader}
        actionBtnFunc={() => {
          DeleteGratitude(id);
        }}
        loader={loader}
      />
    </div>
  );
}
